module.exports = __webpack_public_path__ + "static/fipcwhitelambsmain-618cd2be97232f78774ed9642aee187a.jpeg";